import React from 'react';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import CreateRoundedIcon from '@mui/icons-material/CreateRounded';
import ActionProcurementBtn from './TopBar/Buttons/ActionProcurementBtn';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import { GridColDef } from '@mui/x-data-grid';
import { NewAddComponentType } from './CustomDataGridStyle';

const style = { top: 2, right: 2, zIndex: 4 };

interface ActionTdElementsProps<T> {
    page: number;
    pageSize: number;
    isResetPassword?: boolean;
    newAddComponent?: NewAddComponentType;
    handleEdit: (row: T) => void;
    handleDelete?: (id: string, confirmation?: boolean) => void;
    handleReset?: (row: T) => Promise<void>;
    handleFeedbackTicket?: (id: string) => void;
}

export const createActionTdElements = <T,>({
    page,
    pageSize,
    newAddComponent,
    isResetPassword = false,
    handleEdit,
    handleDelete,
    handleReset,
    handleFeedbackTicket
}: ActionTdElementsProps<T>): GridColDef => ({

    field: 'actions',
    headerName: '',
    sortable: false,
    width: 200,
    align: 'right',
    headerAlign: 'right',
    cellClassName: 'action-td-position ',
    headerClassName: 'action-td-position ',
    editable: false,
    renderCell: (params) => {
        const isUserComponent = isResetPassword && newAddComponent === 'Users';
        const hideEdit = ['PurchaseRequests', 'RequestForProposals', 'RequestForQuotations'].includes(newAddComponent ?? '');

        const EditButton = () => {
            return handleEdit && <IconButton
                aria-label="edit"
                title='Edit Item'
                sx={{ color: 'var(--btn-color)' }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleEdit(params.row)
                }}
            >
                <CreateRoundedIcon />
            </IconButton>
        }

        const DeleteButton = () => {
            return handleDelete
                && <IconButton
                    aria-label="delete"
                    title='Delete Item'
                    sx={{ color: '#FF3E12' }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleDelete(params.row.id)
                    }}
                >
                    <DeleteIcon />
                </IconButton>
        }

        const ResetButton = () => {
            return handleReset
                && <IconButton
                    aria-label="reset"
                    title='Reset Password'
                    sx={{ color: '#185EA5' }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleReset(params.row);
                    }}
                >
                    <LockResetOutlinedIcon />
                </IconButton>;
        }

        const FeedBackButton = () => {
            return newAddComponent === 'Ticket'
                && handleFeedbackTicket
                && <IconButton
                    aria-label="Feedback"
                    title='Feedback'
                    sx={{ color: '#185EA5' }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleFeedbackTicket(params.row.id);
                    }}
                >
                    <ChatOutlinedIcon />
                </IconButton>
        }

        const ActionProBtn = () => {
            return hideEdit && (
                <span
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                >
                    <ActionProcurementBtn
                        id={params.row.id}
                        page={page}
                        pageSize={pageSize}
                        newAddComponent={newAddComponent}
                        handleDelete={handleDelete}
                    />
                </span>
            );
        };


        return !isResetPassword
            ? <div className={`position-absolute action-buttons ${!hideEdit && 'showIconHover'}`} style={style}>
                {FeedBackButton()}
                {ActionProBtn()}
                {!hideEdit && EditButton()}
                {!hideEdit && DeleteButton()}
            </div>
            : isUserComponent
                ? <div className='position-absolute action-buttons showIconHover' style={style}>
                    {ResetButton()}
                    {EditButton()}
                    {DeleteButton()}
                </div>
                : <div className='position-absolute action-buttons showIconHover' style={style}>
                    {ResetButton()}
                </div>
    }
});
